export default [
  {
    path: '/app/products',
    name: 'Products',
    component: () => import('@/views/Admin/Products/Index.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/products/add',
    name: 'ProductAdd',
    component: () => import('@/views/Admin/Products/Add.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Ürün Ekle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/products/edit/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Admin/Products/Edit.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_EDIT',
      action: 'read',
    },
  },
  {
    path: '/app/products/view/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Admin/Products/View.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_VIEW',
      action: 'read',
    },
  },
  {
    path: '/app/products/additem/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Admin/Products/AddItems.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Malzeme Ekle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_EDIT',
      action: 'read',
    },
  },
  {
    path: '/app/products/edititem/:id',
    name: 'ProductEdit',
    component: () => import('@/views/Admin/Products/EditItem.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/products',
          active: false,
        },
        {
          text: 'Malzeme Düzenle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_EDIT',
      action: 'read',
    },
  },
]
